"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _uxTreadDotcomConstants = require("@nike/ux-tread-dotcom-constants");
var _debouncePromise = _interopRequireDefault(require("debounce-promise"));
var _getWebshellclientLocale = _interopRequireDefault(require("../../../../../utils/get-webshellclient-locale"));
var _trackEvent = _interopRequireDefault(require("../../../../../analytics/track-event"));
var _patchCart = _interopRequireDefault(require("../api-calls/patch-cart"));
var _replaceItems = _interopRequireDefault(require("../api-calls/replace-items"));
var _createItemData = _interopRequireDefault(require("../utils/create-item-data"));
var _updateCartReviewsTotals = _interopRequireDefault(require("../utils/update-cart-reviews-totals"));
var _getQueryKey = _interopRequireDefault(require("../get-query-key"));
var _getQueryKey2 = _interopRequireDefault(require("../../../cart_reviews/v2/get-query-key"));
var _getQueryKey3 = _interopRequireDefault(require("../../../partner_cart_reviews/v1/get-query-key"));
var _getQueryKey4 = _interopRequireDefault(require("../../../partner_cart_reviews/v2/get-query-key"));
var _handleErrors = _interopRequireDefault(require("../utils/handle-errors"));
var _handleWarnings = _interopRequireDefault(require("../utils/handle-warnings"));
var _activeUpdateRequests = require("../utils/active-update-requests");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var trackItemUpdated = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(data, itemData) {
    var _data$items, updatedItem, productCode, gtin, priceInfo, cartId, currency, _window$webShellClien, toUnitsNanos, getProtoEnums, CurrencyEnums, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          _context.p = 0;
          updatedItem = data === null || data === void 0 || (_data$items = data.items) === null || _data$items === void 0 ? void 0 : _data$items.find(function (item) {
            return item.id === itemData.id;
          });
          if (!(!updatedItem || !(data !== null && data !== void 0 && data.id))) {
            _context.n = 1;
            break;
          }
          return _context.a(2);
        case 1:
          productCode = updatedItem.productCode, gtin = updatedItem.gtin, priceInfo = updatedItem.priceInfo;
          cartId = data.id, currency = data.currency;
          _window$webShellClien = window.webShellClient.analytics.utils, toUnitsNanos = _window$webShellClien.toUnitsNanos, getProtoEnums = _window$webShellClien.getProtoEnums;
          _context.n = 2;
          return getProtoEnums('Currency');
        case 2:
          CurrencyEnums = _context.v;
          window.webShellClient.analytics.trackAction({
            underlyingAction: {
              "case": 'coreCommerceV1CartModified',
              value: {
                cartId: cartId,
                operation: {
                  "case": 'itemUpdated',
                  value: {
                    product: {
                      "case": 'consumerProduct',
                      value: {
                        productCode: {
                          value: productCode
                        },
                        gtin: {
                          value: gtin
                        }
                      }
                    },
                    quantity: itemData.quantity,
                    currency: CurrencyEnums[currency === null || currency === void 0 ? void 0 : currency.toUpperCase()],
                    fullPriceTotal: toUnitsNanos(priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.fullPriceTotal),
                    currentPriceTotal: toUnitsNanos(priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.total)
                  }
                }
              }
            }
          }, {
            eventVersion: 2
          });
          (0, _trackEvent["default"])('Product Quantity Updated', itemData.prevQty ? {
            mouseTarget: "qty updated from ".concat(itemData.prevQty, " to ").concat(itemData.quantity)
          } : null, {
            telemetryData: {
              prevQty: itemData.prevQty,
              quantity: itemData.quantity,
              skuId: itemData.skuId
            },
            usePageAction: true
          });
          _context.n = 4;
          break;
        case 3:
          _context.p = 3;
          _t = _context.v;
        case 4:
          return _context.a(2);
      }
    }, _callee, null, [[0, 3]]);
  }));
  return function trackItemUpdated(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
function updateCartItem(_ref2) {
  var _getWebShellClientLoc;
  var cloudStack = _ref2.cloudStack,
    giftCard = _ref2.giftCard,
    id = _ref2.id,
    items = _ref2.items,
    offer = _ref2.offer,
    offers = _ref2.offers,
    quantity = _ref2.quantity,
    recipient = _ref2.recipient,
    shippingAddress = _ref2.shippingAddress,
    shippingMethod = _ref2.shippingMethod,
    skuId = _ref2.skuId,
    valueAddedServices = _ref2.valueAddedServices,
    fetchOptions = _ref2.fetchOptions;
  var itemDataToMerge = (0, _createItemData["default"])();
  var params = {
    fetchOptions: fetchOptions,
    cloudStack: cloudStack,
    appId: _uxTreadDotcomConstants.DOTCOM_UX_ID,
    brand: _uxTreadDotcomConstants.NIKE_BRAND,
    channel: _uxTreadDotcomConstants.NIKECOM_CHANNEL,
    country: (_getWebShellClientLoc = (0, _getWebshellclientLocale["default"])().country) === null || _getWebShellClientLoc === void 0 ? void 0 : _getWebShellClientLoc.toUpperCase(),
    items: items ? items.map(function (item) {
      return _objectSpread(_objectSpread({}, itemDataToMerge), item);
    }) : [_objectSpread({
      giftCard: giftCard,
      id: id,
      offer: offer,
      offers: offers,
      quantity: quantity,
      recipient: recipient,
      shippingAddress: shippingAddress,
      shippingMethod: shippingMethod,
      skuId: skuId,
      valueAddedServices: valueAddedServices
    }, itemDataToMerge)]
  };
  return (0, _replaceItems["default"])(params);
}
var isItemInCart = function isItemInCart(queryClient, itemId) {
  var _cart$items;
  var cart = queryClient.getQueryData((0, _getQueryKey["default"])());
  return cart === null || cart === void 0 || (_cart$items = cart.items) === null || _cart$items === void 0 ? void 0 : _cart$items.some(function (item) {
    return item.id === itemId;
  });
};
var updateOrPatch = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_ref3) {
    var itemData, queryClient, mutationId, abortController, data, _t2, _t3;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          itemData = _ref3.itemData, queryClient = _ref3.queryClient;
          mutationId = itemData.id;
          if (isItemInCart(queryClient, mutationId)) {
            _context2.n = 1;
            break;
          }
          return _context2.a(2, queryClient.getQueryData((0, _getQueryKey["default"])()));
        case 1:
          if (_activeUpdateRequests.activeUpdateRequests.has(mutationId)) {
            _activeUpdateRequests.activeUpdateRequests.get(mutationId).abort();
            _activeUpdateRequests.activeUpdateRequests["delete"](mutationId);
          }
          abortController = new AbortController();
          _activeUpdateRequests.activeUpdateRequests.set(mutationId, abortController);
          _context2.p = 2;
          if (!itemData.actions) {
            _context2.n = 4;
            break;
          }
          _context2.n = 3;
          return (0, _patchCart["default"])(_objectSpread(_objectSpread({}, itemData), {}, {
            fetchOptions: {
              signal: abortController.signal
            }
          }));
        case 3:
          _t2 = _context2.v;
          _context2.n = 6;
          break;
        case 4:
          _context2.n = 5;
          return updateCartItem(_objectSpread(_objectSpread({}, itemData), {}, {
            fetchOptions: {
              signal: abortController.signal
            }
          }));
        case 5:
          _t2 = _context2.v;
        case 6:
          data = _t2;
          if (isItemInCart(queryClient, mutationId)) {
            _context2.n = 7;
            break;
          }
          return _context2.a(2, queryClient.getQueryData((0, _getQueryKey["default"])()));
        case 7:
          queryClient.setQueryData((0, _getQueryKey["default"])(), data);
          _context2.n = 8;
          return queryClient.invalidateQueries({
            queryKey: (0, _getQueryKey2["default"])()
          });
        case 8:
          _context2.n = 9;
          return queryClient.invalidateQueries({
            queryKey: (0, _getQueryKey4["default"])()
          });
        case 9:
          _context2.n = 10;
          return queryClient.invalidateQueries({
            queryKey: (0, _getQueryKey3["default"])()
          });
        case 10:
          if (!(data !== null && data !== void 0 && data.warnings && data.warnings.length > 0)) {
            _context2.n = 11;
            break;
          }
          _context2.n = 11;
          return (0, _handleWarnings["default"])({
            warnings: data.warnings,
            data: data
          }, queryClient);
        case 11:
          // Not awaited — fire-and-forget so analytics don't block the mutation
          trackItemUpdated(data, itemData);
          return _context2.a(2, data);
        case 12:
          _context2.p = 12;
          _t3 = _context2.v;
          if (!(_t3.name === 'AbortError')) {
            _context2.n = 13;
            break;
          }
          return _context2.a(2, queryClient.getQueryData((0, _getQueryKey["default"])()));
        case 13:
          throw _t3;
        case 14:
          _context2.p = 14;
          if (_activeUpdateRequests.activeUpdateRequests.get(mutationId) === abortController) {
            _activeUpdateRequests.activeUpdateRequests["delete"](mutationId);
          }
          return _context2.f(14);
        case 15:
          return _context2.a(2);
      }
    }, _callee2, null, [[2, 12, 14, 15]]);
  }));
  return function updateOrPatch(_x3) {
    return _ref4.apply(this, arguments);
  };
}();

// Create a map to store debounced functions with different delays
var debouncedFnMap = new Map();
var getDebouncedMutationFn = function getDebouncedMutationFn(debounceTime) {
  // Use existing debounced function if one exists for this delay
  if (!debouncedFnMap.has(debounceTime)) {
    var debouncedFn = (0, _debouncePromise["default"])(updateOrPatch, debounceTime);
    debouncedFnMap.set(debounceTime, debouncedFn);
  }
  return debouncedFnMap.get(debounceTime);
};
var getUpdateItemOptions = function getUpdateItemOptions(_ref5) {
  var queryClient = _ref5.queryClient,
    debounceTime = _ref5.debounceTime;
  var _mutationFn = debounceTime ? getDebouncedMutationFn(debounceTime) : updateOrPatch;
  return {
    mutationFn: function mutationFn(_ref6) {
      var itemData = _ref6.itemData;
      return _mutationFn({
        itemData: itemData,
        queryClient: queryClient
      });
    },
    onMutate: function () {
      var _onMutate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(_ref7) {
        var itemData, queryKey;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              itemData = _ref7.itemData;
              // in 'carts' - update cart item price and quantity onMutate
              queryKey = (0, _getQueryKey["default"])({
                queryClient: queryClient
              });
              queryClient.setQueryData(queryKey, function (currentCart) {
                var items = currentCart.items;
                return _objectSpread(_objectSpread({}, currentCart), {}, {
                  items: items.map(function (item) {
                    if (item.id === itemData.id) {
                      var newPriceInfo = item.priceInfo;
                      if (itemData.prevQty) {
                        var newQuantity = itemData.quantity;
                        var priceInfo = item.priceInfo,
                          quantity = item.quantity;
                        var discount = priceInfo.discount,
                          price = priceInfo.price,
                          fullPrice = priceInfo.fullPrice;
                        var discountPerItem = discount / quantity;
                        var totalDiscount = discountPerItem * newQuantity;
                        newPriceInfo = _objectSpread(_objectSpread({}, priceInfo), {}, {
                          discount: totalDiscount,
                          total: price * newQuantity - totalDiscount,
                          subtotal: price * newQuantity,
                          fullPriceTotal: fullPrice * newQuantity
                        });
                      }
                      return _objectSpread(_objectSpread(_objectSpread({}, item), itemData), {}, {
                        priceInfo: newPriceInfo
                      });
                    } else {
                      return item;
                    }
                  })
                });
              });
              _context3.n = 1;
              return (0, _updateCartReviewsTotals["default"])({
                queryClient: queryClient
              });
            case 1:
              return _context3.a(2, {
                meta: {
                  dispatchCartUpdated: true,
                  dispatchCartCountUpdated: true
                }
              });
          }
        }, _callee3);
      }));
      function onMutate(_x4) {
        return _onMutate.apply(this, arguments);
      }
      return onMutate;
    }(),
    onError: function () {
      var _onError = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(error, variables) {
        var _t4;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              _context4.n = 1;
              return (0, _handleErrors["default"])({
                error: error,
                params: variables
              }, queryClient);
            case 1:
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t4 = _context4.v;
            case 3:
              return _context4.a(2);
          }
        }, _callee4, null, [[0, 2]]);
      }));
      function onError(_x5, _x6) {
        return _onError.apply(this, arguments);
      }
      return onError;
    }()
  };
};
var _default = exports["default"] = getUpdateItemOptions;